module.exports = __webpack_public_path__ + "static/3-75e83c0689bf4496e77d40ae62438091.svg";